<template>
  <div
    class="grid lg:grid-cols-2 relative lg:h-screen pb-8 lg:pb-0 tracking-wider"
  >
    <div class="px-4 lg:h-full lg:overflow-auto">
      <div class="py-8 px-4 space-y-8 tracking-wider bloc" v-html="info.text"></div>
    </div>
    <div class="hidden lg:block py-4 absolute top-0 left-1/2 w-px h-full">
      <div class="w-full h-full bg-black"></div>
    </div>
    <updates-bar />
  </div>
</template>

<script>
const UpdatesBar = () =>
  import(/* webpackChunkName: "UpdatesBar" */ "@/components/UpdatesBar.vue");
export default {
  components: {
    UpdatesBar
  },
  created() {
    if (!this.$store.state.info.title) this.$store.dispatch("loadInfo");
  },
  computed: {
    info() {
      return this.$store.state.info;
    },
  },
};
</script>
